export default "__VITE_ASSET__DCQVgMts__"